import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNuxtDotJsComponent } from './simple-icons-nuxt-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNuxtDotJsComponent ],
    exports:      [ SimpleIconsNuxtDotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsNuxtDotJsModule {}
